import { Component, signal, WritableSignal } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MatDialogClose } from "@angular/material/dialog";
import { environment } from "../../../../../../../environments/environment";
import { CopyToClipboardCopiedDirective } from "../../../directives/copy-to-clipboard-copied.directive";

@Component({
  selector: 'app-dialog-desktop-benefits',
  imports: [
    MatIcon,
    MatDialogClose,
    CopyToClipboardCopiedDirective
  ],
  templateUrl: './dialog-desktop-benefits.component.html',
  styleUrl: './dialog-desktop-benefits.component.scss'
})
export class DialogDesktopBenefitsComponent {
  public readonly linkWebVersion: WritableSignal<string> = signal(environment.linkWebVersion);
}
